import api from '@/api'

const state = {

}

const mutations = {

}

const actions = {
  printSupOrder ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.printSupOrder(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pOrder/printSupOrder', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pOrder/printSupOrder', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  listSupOrderWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listSupOrderWithPage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pOrder/listSupOrderWithPage', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pOrder/listSupOrderWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  confirmHavePurchaseOrder ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.confirmHavePurchaseOrder(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pOrder/confirmHavePurchaseOrder', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pOrder/confirmHavePurchaseOrder', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  confirmNoPurchaseOrder ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.confirmNoPurchaseOrder(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pOrder/confirmNoPurchaseOrder', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pOrder/confirmNoPurchaseOrder', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  mapListInstockWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListInstockWithPage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pOrder/mapListInstockWithPage', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pOrder/mapListInstockWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  mapListReturnWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListReturnWithPage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pOrder/mapListReturnWithPage', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pOrder/mapListReturnWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  isFristNotice ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.isFristNotice(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pOrder/isFristNotice', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pOrder/isFristNotice', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  noticeRead ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.noticeRead(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pOrder/noticeRead', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pOrder/noticeRead', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 预约送货相关
  // 获取待预约列表
  getNobookingList ({ commit, dispatch }, type) {
    return new Promise((resolve, reject) => {
      api.listNobookingInfo(type).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/booking/listNobookingInfo', error: resData.error })
          }
        }
      })
    })
  },
  // 预约预占
  getPreOccupyData ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.preOccupy(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/booking/preOccupy', error: resData.error })
          }
        }
      })
    })
  },
  // 预约预占
  getWarehouseConfig ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getWarehouseConfig(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/booking/getWarehouseConfig', error: resData.error })
          }
        }
      })
    })
  },
  // 预约
  createReserve ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.createReserve(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/booking/create', error: resData.error })
          }
        }
      })
    })
  },
  // 取消预约
  cancelReserve ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.cancelReserve(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/booking/cancel', error: resData.error })
          }
        }
      })
    })
  },
  // 获取已预约列表
  getBookingList ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listbookingInfo(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/booking/listbookingInfo', error: resData.error })
          }
        }
      })
    })
  },
  uploadWarehouseOrder ({ commit, dispatch }, data) { // 上传入库验收单
    return new Promise((resolve, reject) => {
      api.uploadWarehouseOrder(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pOrder/uploadWarehouseOrder', error: resData.error })
          }
        }
      })
    })
  },
  listWarehouseOrderByStatus ({ commit, dispatch }, data) { // 根据状态获取入库验收单列表
    return new Promise((resolve, reject) => {
      api.listWarehouseOrderByStatus(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pOrder/listWarehouseOrderByStatus', error: resData.error })
          }
        }
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js